import { Component } from '@angular/core';

@Component({
  selector: 'app-statements',
  templateUrl: './statements.component.html',
  standalone: false,
})
export class StatementsComponent {}
